import React from 'react';
import Switch from 'components/mui/Form/Switch/SwitchBase';
import { FormControlLabelSwitch } from 'components/mui/Form/FormControl/FormControlLabelSwitch';

// TODO: switch is WIP

const SwitchForm = (props) => {
  const { input, SwitchProps = {}, FormControlLabelProps = {} } = props;
  const { onChange, value } = input;

  return (
    <FormControlLabelSwitch
      color="primary"
      checked={value}
      control={<Switch onChange={onChange} {...SwitchProps} />}
      {...FormControlLabelProps}
    />
  );
};

export default SwitchForm;
